import { UserTypeProvider } from "@/providers/UserTypeProvider";
import { Outlet } from "react-router-dom";

function PublicRouteLayout() {
  return (
    <UserTypeProvider type={"external"}>
      <div>
        <div style={{ background: "#F0F2F5" }}>
          <Outlet />
        </div>
      </div>
    </UserTypeProvider>
  );
}

export default PublicRouteLayout;
